<div [class]="'modal-container ' + (data.tamanhoModal ? data.tamanhoModal : 'small')">
	<div mat-dialog-title>
		<h1>{{ data.tituloModal }}</h1>
		<button mat-icon-button class="close-icon" [mat-dialog-close]="false">
			<mat-icon>close</mat-icon>
		</button>
	</div>
	<div class="body">
		<div mat-dialog-content>
			<ng-content select="[content]"></ng-content>
		</div>
		<div mat-dialog-actions>
			<ng-content select="[cancel-button]"></ng-content>
			<ng-content select="[confirm-button]"></ng-content>
		</div>
	</div>
</div>
